import { Component, HostBinding, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Observable, Subject } from 'rxjs';
import { delay, shareReplay } from 'rxjs/operators';

import { LoaderService } from './loader/loader.service';
import { LoaderConfig, defaultLoaderConfig } from './loader/loader.config';
import { StompWebSocketService } from '../core/services/stomp-websocket.service';
import { UserManualService } from '../shared/user-manual/user-manual.service';
import { env } from '../../environments/env';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('{{ delay }}')], {
        delay: '0.1s 3000ms ease-in-out',
      }),
    ]),
  ],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  public animationTime = '0.1s 0ms ease-in-out';
  public manualActive$: Observable<boolean> | undefined;

  @Input()
  akerTitle = '';

  @Input()
  titleClickUrl = '';

  @Input()
  hideUserLogin = false;

  @Input()
  logoClickUrl = 'https://www.akersolutions.com/';

  @HostBinding('class.app-header')
  classAppHeader = true;
  private loaderConfig: LoaderConfig = defaultLoaderConfig;
  public isLoading: Observable<boolean>;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private loaderService: LoaderService,
    private readonly stompService: StompWebSocketService,
    private readonly userManualService: UserManualService,
  ) {
    this.isLoading = this.loaderService.isLoadingStream.pipe(delay(0), shareReplay(1));
    this.manualActive$ = this.userManualService.manualActive$;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (env.get().featureFlags.stomp) {
      this.stompService.disconnect();
    }
  }

  public async ngOnInit(): Promise<void> {
    if (this.loaderConfig?.delayLoadbar != null) {
      this.setDelayForLoadbar(this.loaderConfig.delayLoadbar);
    }

    if (env.get().featureFlags.stomp) {
      // TODO look into this when we have have the
      // this.stompService.connect();
      //
      // this.stompService.incomingMessages$
      //   .pipe(takeUntil(this.destroy$))
      //   .subscribe(msg => {
      //     console.log('WebSocket notification:', msg.body);
      //   });
    }
  }

  private setDelayForLoadbar(delay: number): void {
    const next = `0.1s ${delay}ms ease-in-out`;
    if (this.animationTime === next) return; // no change
    // Defer assignment to a microtask so initial CD pass finishes before value changes.
    Promise.resolve().then(() => {
      this.animationTime = next;
      // If needed we could markForCheck; default change detection will pick this up.
    });
  }
}
